export const MEMBERSHIP_STATES = {
  VISITOR: 'visitor',
  LEAD: 'lead',
  VIP: 'vip',
  ELITE: 'elite',
};

export const productDetailPath = 'products';
